import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import LoadingCentered from "./loaders/loadingcentered";
import { generatePdfReport } from "../api";

// https://www.ag-grid.com/javascript-data-grid/grid-api/

export function PdfReport({json, onCloseReport, lng }) {
  const { t, i18n } = useTranslation("translations", {lng});
  const [objectURL, setObjectURL] = useState("");
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    async function fetchReport() {
      setObjectURL("");
      setShowLoading(true);
      if (json !== null) {
        if (json.common !== undefined) {
          json.common.language = i18n.resolvedLanguage;
        }
        const res = await generatePdfReport("esalary-common", json);
        setObjectURL(URL.createObjectURL(res.data));
        setShowLoading(false);
      //window.open(objectURL, "_blank");
      }
    }
    fetchReport();
    
  }, [json]);

  return (
    <Modal show={json !== null} onHide={onCloseReport} size="xl" fullscreen="lg-down">
      <Modal.Header closeButton onHide={onCloseReport}>{t("PdfReport", "Pdf-raportti")}</Modal.Header>
      <LoadingCentered show={showLoading} />
      <iframe style={{height: "85vh"}} src={objectURL} />
    </Modal>
  );
}
